var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    role: "img",
    "aria-label": "Roman Volkonidov",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Roman Volkonidov") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,256) scale(1.42) translate(-256,-256) translate(0,-15)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    d: "       M 108 150 L 200 150       C 242 150 270 177 270 208       C 270 235 254 256 231 265       L 274 330 L 223 330 L 186 271 L 154 271 L 154 330 L 108 330 Z       M 154 190 L 154 233 L 197 233       C 212 233 223 224 223 211       C 223 199 212 190 197 190 Z     "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M 284 150 L 328 150 L 344 268 L 360 150 L 404 150 L 344 330 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6C8CD",
    d: "       M 120 358 C 168 348 216 348 256 358 C 296 348 344 348 392 358       L 392 392 C 344 382 296 382 256 392 C 216 382 168 382 120 392 Z     "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.e2e6a677b9e3329b7e41e3264d0e4f14.svg";
export { ForwardRef as ReactComponent };